import { FieldStatusEnum } from '../../types/enums/affected-staff/field-status.enum'
import { StaffPositionEnum } from '../../types/enums/staff/staff-position.enum'
import { StaffCoordinatesFilters } from '../../types/models/staff/staff'

export const transformStaffCoordinatesFiltersToUrl = (
  filters?: StaffCoordinatesFilters
): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.ibanStatus && filters.ibanStatus.length)
    searchParams.append('ibanStatus', filters.ibanStatus.join(','))

  if (filters.position && filters.position.length)
    searchParams.append('position', filters.position.join(','))

  if (filters.ibanExported !== undefined)
    searchParams.append('ibanExported', filters.ibanExported ? 'true' : 'false')

  return searchParams.toString()
}

export const transformUrlToStaffCoordinatesFilters = (
  searchParams: URLSearchParams
): StaffCoordinatesFilters => {
  const filters: StaffCoordinatesFilters = {}

  const ibanStatus = searchParams.get('ibanStatus')
  if (ibanStatus) filters.ibanStatus = ibanStatus.split(',') as FieldStatusEnum[]

  const position = searchParams.get('position')
  if (position) filters.position = position.split(',') as StaffPositionEnum[]

  const ibanExported = searchParams.get('ibanExported')
  if (ibanExported !== null) filters.ibanExported = ibanExported === 'true'

  return filters
}
